import { cwslapi } from "../index";

// 获取星际双翼秘宝活动信息
export const getInfoApi = (data) => {
  return cwslapi({
    url: "/starWingTreasure/getInfo",
    method: "post",
    data,
  });
};

// 金龙元宝兑换星际币
export const exchangeApi = (data) => {
  return cwslapi({
    url: "/starWingTreasure/exchangeCurrency",
    method: "post",
    data,
  });
};

// 普通单抽或十连抽
export const doLotteryApi = (data) => {
  return cwslapi({
    url: "/starWingTreasure/draw",
    method: "post",
    data,
  });
};

// 抽取特别奖励
export const drawSpecialApi = (data) => {
  return cwslapi({
    url: "/starWingTreasure/drawSpecial",
    method: "post",
    data,
  });
};

// 使用秘宝碎片兑换商店道具
export const buyHiddenShopItemApi = (data) => {
  return cwslapi({
    url: "/starWingTreasure/exchangeShopItem",
    method: "post",
    data,
  });
};

// 获取秘宝碎片商店列表
export const getShopListApi = (data) => {
  return cwslapi({
    url: "/starWingTreasure/shopList",
    method: "post",
    data,
  });
};

// 获取个人抽奖记录
export const getActivityLogApi = (data) => {
  return cwslapi({
    url: "/starWingTreasure/getPrizeLog",
    method: "post",
    data,
  });
};

// 获取最近抽奖记录
export const getRecentPrizeLogApi = (data) => {
  return cwslapi({
    url: "/starWingTreasure/getRecentPrizeLog",
    method: "post",
    data,
  });
};

// 领取800或4800抽里程碑奖励
export const claimMilestoneRewardApi = (data) => {
  return cwslapi({
    url: "/starWingTreasure/claimMilestone",
    method: "post",
    data,
  });
};